import { Injectable } from '@angular/core';
import { ReportSettingModel } from '@app/core/Models/report/report-settings/report-setting';
import { ReportSettingsService } from '@app/core/Services';
import { Action, State, StateContext } from '@ngxs/store';
import { Guid } from 'guid-typescript';
import { tap } from 'rxjs/operators';
import { DeleteContact, DeleteExaminer, GetAllContactsBasedonId, GetAllContactsBasedonType, GetAllIndependentExaminers, GetBalancesheetDataById, GetExaminersBasedonId, GetTrusteesDataById, GetTrusteesDataByPeriodId, SaveBalancesheetDisclosures, SaveCompanyContacts, SaveIndependentExaminers, SaveTrusteeDisclosures } from './report-settings.action';

export class ReportSettingStateInfo {
  contactDetails?: ReportSettingModel 
  contacts?: [];
  contactId?: Guid;
  isSuccess?: any;
  balancesheetReportDetails?: any;
  trusteeReportDetails?: any;
  examiners?: any;
  examinerDetails?: any;
  iscompanyRegistered?:boolean;
  isAudited?:boolean;
  commencementDate?:any;
  charityType?:number;
}

@State<ReportSettingStateInfo>({
  name: 'reportSettings',
  defaults: {
    contacts: [],
    isSuccess: true
  },
})
@Injectable()
export class ReportSettingState {
  constructor(private reportSettingService: ReportSettingsService) {}

  @Action(GetAllContactsBasedonType)
  getAllContactsBasedonType(
    { patchState }: StateContext<ReportSettingStateInfo>,
    action: GetAllContactsBasedonType
  ) {
    return this.reportSettingService.getAllContactsBasedonType(action.contactType)
      .pipe(
        tap((res) => {
          patchState({
            contacts: res?.contacts,
            iscompanyRegistered: res?.iscompanyRegistered,
            isAudited:res?.isAudited,
            commencementDate:res?.commencementDate,
            charityType:res?.charityType
          });
        })
      );
  }

  @Action(GetAllContactsBasedonId)
  getAllContactsBasedonId(
    { patchState }: StateContext<ReportSettingStateInfo>,
    action: GetAllContactsBasedonId
  ) {
    return this.reportSettingService.getAllContactsBasedonId(action.contactId)
      .pipe(
        tap((res) => {
          patchState({
            contactDetails: res,
          });
        })
      );
  }

  @Action(SaveCompanyContacts)
  SaveCompanyContacts(
    { patchState }: StateContext<ReportSettingStateInfo>,
    action: SaveCompanyContacts
  ) {
    return this.reportSettingService.saveCompanyContacts(action.contactDetails)
      .pipe(
        tap((res) => {
          patchState({
            isSuccess: res,
          });
        })
      );
  }

  @Action(DeleteContact)
  Deletecontact(
    { patchState }: StateContext<ReportSettingStateInfo>,
    action: DeleteContact
  ) {
    return this.reportSettingService.deleteContact(action.contactId)
      .pipe(
        tap((res) => {
          patchState({
            isSuccess: res,
          });
        })
      );
  }

  @Action(GetTrusteesDataById)
  GetTrusteesDataById(
    { patchState }: StateContext<ReportSettingStateInfo>,
    action: GetTrusteesDataById
  ) {
    return this.reportSettingService.getTrusteesDataById(action.type)
      .pipe(
        tap((res) => {
          patchState({
            trusteeReportDetails: res,
          });
        })
      );
  }

  @Action(GetTrusteesDataByPeriodId)
  GetTrusteesDataByPeriodId(
    { patchState }: StateContext<ReportSettingStateInfo>,
    action: GetTrusteesDataByPeriodId
  ) {
    return this.reportSettingService.getTrusteesDataByPeriodId(action.type, action.periodId)
      .pipe(
        tap((res) => {
          patchState({
            trusteeReportDetails: res,
          });
        })
      );
  }

  @Action(SaveTrusteeDisclosures)
  SaveTrusteeDisclosures(
    { patchState }: StateContext<ReportSettingStateInfo>,
    action: SaveTrusteeDisclosures
  ) {
    return this.reportSettingService.saveTrusteeDisclosures(action.reportDetails)
      .pipe(
        tap((res) => {
          patchState({
            isSuccess: res,
          });
        })
      );
  }

  @Action(GetBalancesheetDataById)
  GetBalancesheetDataById(
    { patchState }: StateContext<ReportSettingStateInfo>,
    action: GetBalancesheetDataById
  ) {
    return this.reportSettingService.getBalancesheetDataById(action.type)
      .pipe(
        tap((res) => {
          patchState({
            balancesheetReportDetails: res,
          });
        })
      );
  }

  @Action(SaveBalancesheetDisclosures)
  SaveBalancesheetDisclosures(
    { patchState }: StateContext<ReportSettingStateInfo>,
    action: SaveBalancesheetDisclosures
  ) {
    return this.reportSettingService.saveBalancesheetDisclosures(action.reportDetails)
      .pipe(
        tap((res) => {
          patchState({
            isSuccess: res,
          });
        })
      );
  }

  @Action(GetAllIndependentExaminers)
  GetAllIndependentExaminers(
    { patchState }: StateContext<ReportSettingStateInfo>,
    action: GetAllIndependentExaminers
  ) {
    return this.reportSettingService.getAllIndependentExaminers()
      .pipe(
        tap((res) => {
          patchState({
            examiners: res,
          });
        })
      );
  }

  @Action(GetExaminersBasedonId)
  GetExaminersBasedonId(
    { patchState }: StateContext<ReportSettingStateInfo>,
    action: GetExaminersBasedonId
  ) {
    return this.reportSettingService.getExaminersBasedonId(action.examinerId)
      .pipe(
        tap((res) => {
          patchState({
            examinerDetails: res,
          });
        })
      );
  }

  @Action(SaveIndependentExaminers)
  SaveIndependentExaminers(
    { patchState }: StateContext<ReportSettingStateInfo>,
    action: SaveIndependentExaminers
  ) {
    return this.reportSettingService.saveIndependentExaminers(action.examinerDetails)
      .pipe(
        tap((res) => {
          patchState({
            isSuccess: res,
          });
        })
      );
  }

  @Action(DeleteExaminer)
  DeleteExaminer(
    { patchState }: StateContext<ReportSettingStateInfo>,
    action: DeleteExaminer
  ) {
    return this.reportSettingService.deleteExaminer(action.examinerId)
      .pipe(
        tap((res) => {
          patchState({
            isSuccess: res,
          });
        })
      );
  }
}
